var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallCalendarDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.733 5h-.882a.44.44 0 0 0-.441.441v3.087a.44.44 0 0 0 .441.441h.882a.44.44 0 0 0 .441-.441V5.441A.44.44 0 0 0 10.733 5zM20.435 8.969h-.882a.441.441 0 0 1-.441-.441V5.441c0-.243.198-.441.441-.441h.882c.243 0 .441.198.441.441v3.087a.441.441 0 0 1-.441.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.404 6.764h-2.646V9.41a.441.441 0 0 1-.441.441h-2.646a.441.441 0 0 1-.441-.441V6.764h-6.174V9.41a.441.441 0 0 1-.441.441H8.969a.441.441 0 0 1-.441-.441V6.764H5.882A.882.882 0 0 0 5 7.646v16.758c0 .487.395.882.882.882h18.522a.882.882 0 0 0 .882-.882V7.646a.882.882 0 0 0-.882-.882zm-.441 17.64H6.323a.441.441 0 0 1-.441-.441V12.056c0-.243.198-.441.441-.441h17.64c.243 0 .441.198.441.441v11.907a.441.441 0 0 1-.441.441z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallCalendarDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-calendar-default.f810dcdaa003b9ddedb26f74469f7b12.svg";